<template>
  <div class="page-content">
    <div class="content">
      <div class="search">
        <el-form :inline="true" :model="filters" :size="size" @keyup.enter.native="handleQuery" @submit.native.prevent>
          <el-form-item>
            <el-select v-model="filters.name" filterable placeholder="客户">
              <!-- <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.type" filterable placeholder="类型">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.status" filterable placeholder="状态">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="filters.date"
              type="date"
              placeholder="派单时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button :size="size" type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <el-table :data="tableData" style="width: 100%" height="680"
          header-cell-class-name='table-header-cell' cell-class-name='table-cell'
          border stripe fit show-overflow-tooltip highlight-current-row
          >
          <el-table-column prop="name" label="工单名称" min-width="200"></el-table-column>
          <el-table-column prop="address" label="计划名称" min-width="200"></el-table-column>
          <el-table-column prop="address" label="客户" min-width="200"></el-table-column>
          <el-table-column prop="address" label="类型" min-width="100"></el-table-column>
          <el-table-column prop="creatorNickname" label="派单人" min-width="100"></el-table-column>
          <el-table-column prop="time" label="派单时间" min-width="280"></el-table-column>
          <el-table-column prop="describe" label="现场负责人" min-width="100"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" min-width="220" align="center">
            <template slot-scope="scope">
              <!-- 详情 -->
              <el-button @click.native.prevent="handleDetail(scope.$index, scope.row)" type="text" :size="size" >详情</el-button>
              <!-- 审核 -->
              <!-- <el-button @click.native.prevent="handleAudit(scope.$index, scope.row)" type="text" :size="size" >审核</el-button> -->
              <!-- 驳回 -->
              <el-button @click.native.prevent="handleRejected(scope.$index, scope.row)" type="text" :size="size" >驳回</el-button>
              <!-- 终止 -->
              <el-button @click.native.prevent="handleTermination(scope.$index, scope.row)" type="text" :size="size" >终止</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 详情 -->
    <detail-drawer ref="detailDrawer" v-if="detailDrawerVisible"></detail-drawer>
  </div>
</template>

<script>
import detailDrawer from './detailDrawer.vue'
export default {
  name: 'orderTaskReject',
  components: {
    detailDrawer
  },
  data () {
    return {
      detailDrawerVisible: false,
      typeList: [
        { label: '巡检', value: 'XJ' },
        { label: '巡检', value: 'XJ' },
        { label: '巡检', value: 'XJ' }
      ],
      statusList: [
        { label: '待开始', value: 1 },
        { label: '进行中', value: 2 },
        { label: '待验收', value: 3 },
        { label: '已验收', value: 4 }
      ],
      size: 'small',
      filters: {
        name: '',
        type: '',
        status: '',
        date: ''
      },
      tableData: []
    }
  },
  methods: {
    handleQuery () {},
    handleDetail (index, row) {
      this.detailDrawerVisible = true
      this.$nextTick(() => {
        this.$refs.detailDrawer.init(row)
      })
    },
  }
}
</script>

<style lang="scss">
.table-content {
  .table-header-cell{
    background:rgba(220,225,230,1);
    color: #333;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.page-content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.content {
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  .search {
    text-align: left;
  }
}

.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
